<div class="w-full  sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">


    <!--############################################################-->
    <div class="bg-white rounded-lg p-4">
        <!-- ##########################################################  -->
        <!-- ##########################################################  -->
        <div class="w-full">
            <!-- ##########################################################  --> 
            <div class="grid grid-cols-10">   
                <div class="col-span-8">
                    <!-- ## -->
                    <h2 class="prose prose-xl">Producto <b> {{data.NAME_PS_SERVICES}} </b>  </h2>                       
                        <h2 class="prose prose-xl"><b> Actualizar Proveedor</b></h2>                       
                       <!--  <h2 class="prose "> Editar Guia Entrada </h2>   -->
                    <!-- ## -->
                </div>
                <div class="col-span-1">
                    <!-- ## -->
                    <button class="close " mat-button (click)="closeBtn()"> <mat-icon>close</mat-icon></button>    
                    <!-- ## -->
                </div>
            </div>
            <!-- ##########################################################  -->    
    
        </div>
    <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->
    <mat-divider class="py-2"></mat-divider>
    <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->
    
    
        <form [formGroup]="supplierForm" onsubmit="return false;">
    <!--//-->                                                     
    <!--//-->                                                 
    <div class="grid grid-cols-2 gap-1">
        <!-- ## -->
            <div class="col-span-2">
                            <div>
                                <mat-form-field class="w-1/3">
                                <mat-label> Selecione Proveedor</mat-label>
                                    <input matInput type="text"   formControlName="rutCustomer" readonly>
                                    <mat-icon matPrefix> person </mat-icon>
                                    <button  class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button (click)="showCustomer()"> <mat-icon class="icon-size-5" color="primary" [svgIcon]="'search'"></mat-icon> </button>
                                </mat-form-field>
                                
                            </div>
                            <div>
                                <mat-form-field class="w-3/4">
                                    <input matInput type="text"   formControlName="nameCustores" readonly>
                                    <mat-icon matPrefix> person </mat-icon>
                                </mat-form-field>                          
                            </div>
            </div>
        <!-- ## -->    
    </div>
    <!--//-->   
    <!--//-->   
    <div> 
        <p style="color: rgb(0, 32, 96);background-color:rgb(255, 242, 204);border-style: dotted;">
                    <b>El proveedor es actualizado de forma automatica al realizar una guia de Entrada</b>
        </p>
        <p style="color: rgb(150, 8, 6);background-color:rgb(255, 242, 204);border-style: dotted;">
            <b>NOTA: Este cambio sera valido temporalmente</b>
        </p>        
    </div> 
    <!--//-->                                                 
    <div class="grid grid-cols-2 gap-1">
        <!-- ## -->
            <div class="col-span-2">
                <button
                mat-raised-button
                color="primary"
                [disabled]="supplierForm.invalid"
                (click)="addSupplier()"
                
            >
                Agregar
            </button>
            </div>
        <!-- ## -->    
    </div>
    <!--//-->  
    
        </form>  
    
    </div>
    <!--############################################################-->
    </div>